function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 21 15.5",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20.29 5.84l-2-2.09A2.51 2.51 0 0016.46 3H13V0H0v13h2a2.5 2.5 0 005 0h7a2.5 2.5 0 005 0h2V7.59a2.48 2.48 0 00-.71-1.75zM4.5 14.5A1.5 1.5 0 116 13a1.5 1.5 0 01-1.5 1.5zM12 12H6.79a2.49 2.49 0 00-4.62.12V12H1V1h11zm4.5 2.5A1.5 1.5 0 1118 13a1.5 1.5 0 01-1.5 1.5zM20 12h-1.21a2.5 2.5 0 00-4.58 0H13V4h3.46a1.49 1.49 0 011.07.45l2 2.09a1.47 1.47 0 01.43 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 2h4v1H2z"
})));